import { defineStore } from "pinia";

export const useMedicalCenterStore = defineStore('medicalCenter', {
    state: () => ({
        medicalCenter: {},
        medicalCenters: [],
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading
        },
        setMedicalCenter(medicalCenter) {
            this.medicalCenter = medicalCenter
        },
        setMedicalCenters(medicalCenters) {
            this.medicalCenters = medicalCenters
        },
        addMedicalCenter(medicalCenter) {
            this.medicalCenters.unshift(medicalCenter)
        },
        updateMedicalCenter(medicalCenter) {
            let index = this.medicalCenters.findIndex(cl => cl.id === medicalCenter.id)
            this.medicalCenters.splice(index, 1, medicalCenter)
        },
        deleteMedicalCenter(medicalCenter) {
            let index = this.medicalCenters.findIndex(cl => cl.id === medicalCenter.id)
            this.medicalCenters.splice(index, 1)
        },
    },
});